/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'app/components/common/SideBar.jsx';
import { Breakpoint } from 'react-socks';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';

class Features extends React.Component {
    constructor(props) {
        super(props);

        this.ctaAction = this.ctaAction.bind(this);
        this.featureClick = this.featureClick.bind(this);

    }

    componentDidMount() {
        if (dataLayer) {
            dataLayer.push({
                'event': 'promotionView',
                'ecommerce': {
                    'promoView': {
                        'promotions': [
                            {
                                'id': 'new_features_page',
                                'name': 'New Features',
                                'creative': 'new_features_page',
                                'position': 'new_features_page'
                            }
                        ]
                    }
                },
                //GA 4 params
                'promotion_id': 'new_features_page',
                'promotion_name': 'New Features',
                'creative_name': 'new_features_page',
                'creative_slot': 'new_features_page'
            });
        }
    }

    ctaAction(e) {
        let constants = this.props.app.config.constants;

        e.preventDefault();

        if (this.props.isFreeUser()) {
            this.props.router.navigate('/account/subscription/new?plan=9');
        } else {
            if (this.props.isPlusUser() || this.props.isAgencyPlusUser()) {
                this.props.router.navigate('/account/subscription/plus');
            } else {
                this.props.router.navigate('/account/subscription?change=true');
            }

        }

    }

    featureClick(e) {
        let destination = e.currentTarget.dataset.target;

        if (dataLayer) {
            dataLayer.push({
                'event': 'promotionClick',
                'ecommerce': {
                    'promoView': {
                        'promotions': [
                            {
                                'id': 'new_features_page',
                                'name': 'New Features',
                                'creative': destination,
                                'position': 'new_features_page'
                            }
                        ]
                    }
                },
                //GA 4 params
                'promotion_id': 'new_features_page',
                'promotion_name': 'New Features',
                'creative_name': 'new_features_page',
                'creative_slot': 'new_features_page',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

        switch (destination) {
            case "hashtags":
                this.props.router.navigate("/share/automate");
                break;

            case "everqueue":
                let location = "/queue";
                if (this.props.socials.list.length) {
                    for (let i = 0; i < this.props.socials.list.length; ++i) {
                        if (parseInt(this.props.socials.list[i].activeFlag, 10) === 1) {
                            location = "/queue/everqueue/" + this.props.socials.list[i].id;
                        }
                    }
                }
                this.props.router.navigate(location);
                break;

            case "categories":
                this.props.router.navigate("/queue/categories");
                break;

            case "content-import":
                this.props.router.navigate("/content/import");
                break;

            case "wordpress":
                this.props.router.navigate("/content/connections");
                break;

            case "blogger":
                this.props.router.navigate("/config/socials");
                break;

            case "tiktok":
                this.props.router.navigate("/config/socials");
                break;

            case "reddit":
                this.props.router.navigate("/config/socials");
                break;

            case "wordpressOutput":
                this.props.router.navigate("/config/socials");
                break;

            default:
                break;
        }

    }

    render () {
        let content = null,
            main = null,
            constants = this.props.app.config.constants,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            ctaLabel = 'Start My Free Plus Trial',
            mainCta = null,
            featureCta = null;

        if (this.props.app.configLoaded === false || this.props.app.userLoaded === false) {
            return (
                <Loading/>
            );
        }

        if (this.props.isPlusUser() || this.props.isAgencyPlusUser()) {
            if ((this.props.isProUser() || this.props.isAgencyUser()) && this.props.user.perms.resources.plusTrialAvailable && !this.props.user.plan.trialEndsAt) {
                if (this.props.isProUser()) {
                    ctaLabel = 'Start My Free Agency+ Trial';
                }
            } else if (!this.props.user.plan.trialEndsAt) {
                ctaLabel = 'Upgrade to Plus'
            }
            mainCta = (
                <button className="btn-primary active new-feature-cta-button" onClick={this.ctaAction}>
                    {ctaLabel}
                </button>
            );
            featureCta = (
                <a href="#" onClick={this.ctaAction}>Get Started {'>'}</a>
            );
        }

        main = (
            <div className="new-features">
                <div className="new-feature-cta">
                    <h1>Social Media Power Tools</h1>
                    <h3>dlvr.it just got a whole lot more powerful</h3>
                    {mainCta}
                </div>
                <div className="new-feature right-img">
                    <div className="new-feature-image clickable" data-target="blogger" onClick={this.featureClick} role="link" aria-label="more about blogger">
                        <img width="247" height="auto" src={imageUrl + '/new-features/dlvrit-blogger.png'} srcSet={imageUrl + '/new-features/dlvrit-blogger@2x.png' + " 2x"}/>
                    </div>
                    <div className="new-feature-copy blogger">
                        <div className="feature-name clickable" data-target="blogger" onClick={this.featureClick} role="link" aria-label="more about blogger">
                            Auto Post to Blogger
                        </div>
                        <div className="feature-short-desc">
                            Increase your reach with Google's Blogger
                        </div>
                        <div className="feature-long-desc">
                            Drive more traffic to your original post when you auto share updates, photos and links to Blogger. Boost your visibility by connecting your RSS feeds to Blogger.
                            {featureCta}
                        </div>
                    </div>
                </div>
                <div className="new-feature left-img">
                    <div className="new-feature-image clickable" data-target="hashtags" onClick={this.featureClick} role="link" aria-label="more about hastags">
                        <img width="247" height="149" src={imageUrl + '/new-features/hashtags-new-feature.png'} srcSet={imageUrl + '/new-features/hashtags-new-feature@2x.png' + " 2x"}/>
                    </div>
                    <div className="new-feature-copy everqueue">
                        <div className="feature-name clickable" data-target="hashtags" onClick={this.featureClick} role="link" aria-label="more about hastags">
                            Auto Hashtags
                        </div>
                        <div className="feature-short-desc">
                            Increase engagement and drive traffic with automated hashtags.
                        </div>
                        <div className="feature-long-desc">
                            Simply enter top performing hashtags for each of your content feeds. When dlvr.it posts to your social media pages, we’ll automatically include hashtags with every item.
                            {featureCta}
                        </div>
                    </div>
                </div>
                <div className="new-feature right-img">
                    <div className="new-feature-image clickable" data-target="everqueue" onClick={this.featureClick} role="link" aria-label="more about everqueue">
                        <img src={imageUrl + '/new-features/everqueue-post-recycle-4-nf.png'} srcSet={imageUrl + '/new-features/everqueue-post-recycle-4-nf@2x.png' + " 2x"}/>
                    </div>
                    <div className="new-feature-copy everqueue">
                        <div className="feature-name clickable" data-target="everqueue" onClick={this.featureClick} role="link" aria-label="more about everqueue">
                            EverQueue
                        </div>
                        <div className="feature-short-desc">
                            Recycle your best content. Effortlessly.
                        </div>
                        <div className="feature-long-desc">
                            Add your best articles, blog posts and photos to EverQueue. We fill the gaps in your social media schedule with your EverQueue items. After we post an item, it's recycled back into EverQueue.
                            {featureCta}
                        </div>
                    </div>
                </div>
                <div className="new-feature left-img">
                    <div className="new-feature-image clickable" data-target="categories" onClick={this.featureClick} role="link" aria-label="more about categories">
                        <img src={imageUrl + '/new-features/new-features-cat.png'} srcSet={imageUrl + '/new-features/new-features-cat@2x.png' + " 2x"} />
                    </div>
                    <div className="new-feature-copy">
                        <div className="feature-name clickable" data-target="categories" onClick={this.featureClick} role="link" aria-label="more about categories">
                            Category Manager
                        </div>
                        <div className="feature-short-desc">
                            Share the perfect content. Every time.
                        </div>
                        <div className="feature-long-desc">
                            Easily manage different types of content with customized categories and schedules. Make sure the right type of content always goes out on time.
                            {featureCta}
                        </div>
                    </div>
                </div>
                <div className="new-feature right-img">
                    <div className="new-feature-image clickable" data-target="content-import" onClick={this.featureClick} role="link" aria-label="more about import">
                        <img src={imageUrl + '/new-features/new-features-import.png'} srcSet={imageUrl + '/new-features/new-features-import@2x.png' + " 2x"}/>
                    </div>
                    <div className="new-feature-copy">
                        <div className="feature-name clickable" data-target="content-import" onClick={this.featureClick} role="link" aria-label="more about import">
                            Content Search & Import
                        </div>
                        <div className="feature-short-desc">
                            Fill Your Queue. Instantly.
                        </div>
                        <div className="feature-long-desc">
                            Easily fill your queue with quality content from your favorite sources. Import your top blog and social media posts. Or browse the best content from your favorite social media feeds and websites, and share it in seconds.
                            {featureCta}
                        </div>
                    </div>
                </div>
                <div className="new-feature left-img">
                    <div className="new-feature-image clickable" data-target="wordpress" onClick={this.featureClick} role="link" aria-label="more about scheduling">
                        <img src={imageUrl + '/new-features/dlvrit-import-wordpress-2.png'} srcSet={imageUrl + '/new-features/dlvrit-import-wordpress-2@2x.png' + " 2x"}/>
                    </div>
                    <div className="new-feature-copy">
                        <div className="feature-name clickable" data-target="wordpress" onClick={this.featureClick} role="link" aria-label="more about scheduling">
                            WordPress to Social Media Scheduler
                        </div>
                        <div className="feature-short-desc">
                            Import WordPress Posts
                        </div>
                        <div className="feature-long-desc">
                            Schedule weeks worth of social media posts with just a few clicks. Search your WordPress blog for top posts and quickly schedule hundreds of Tweets and Facebook posts. Save hours each week.
                            {featureCta}
                        </div>
                    </div>

                </div>
            </div>
        )

        content = <Content main={main} header={null}/>

        return (
            <div>
                <ErrorBoundary level="view" {...this.props}>
                    <Breakpoint desktop only>
                        <Sidebar navItems={[]}/>
                    </Breakpoint>
                    {content}
                </ErrorBoundary>
            </div>
        );

    }
}

export default Features;
